/**
 * Self Exclusion Model
 */

define(function(require, exports, module) {
    'use strict';

    var _ = require('underscore');
    var BaseModel = require('common/base.model');
    var server = require('server');
    var i18n = require('i18n');

    module.exports = BaseModel.extend({
        id: 'exclusion',

        defaults: {
            isOpenEnded: null
        },

        validationConfig: function() {
            return {
                period: {
                    required: true
                },
                enddate: {
                    fn: {
                        message: i18n.t('playtech.mobile.system.tooltip.required'),
                        fn: function($inputs, fieldValidationConfig, form) {
                            if (form.$el.find('[name=period]').val() === 'enddate') {
                                return !$inputs.some(function(el) {
                                    return !el.value;
                                });
                            }

                            return true;
                        }
                    }
                }
            };
        },

        sync: function(method, model, options) {
            if (method === 'read') {
                return this.read(model, options);
            }

            return this.update(model, options);
        },

        parse: function(response) {
            var data = response.data;
            var allowedProducts = data.products;
            var productSettings = data.productSettings || [];
            var excluded = productSettings.reduce(function(memo, item) {
                if (item.product !== 'external' &&
                    (!item.endDate || Date.now() <= window.Playtech.API.formatter.parseImsDate(item.endDate))) {
                    memo.push(_.extend({}, item, {
                        revoke: _.includes(item.allowedActions, 'revoke')
                    }));
                }

                return memo;
            }, []);
            var minimumAllowedPeriod, maximumAllowedPeriod;

            if (data.crossProduct) {
                allowedProducts.push('all');
            }

            if (data.periods.length) {
                minimumAllowedPeriod = data.periods[0].replace(' ', '');
                maximumAllowedPeriod = data.periods[data.periods.length - 1].replace(' ', '');
            }

            return {
                isExclusionFormAllowed: data.allowed,
                endTypes: data.endTypes,
                periods: data.periods,
                minimumAllowedPeriod: minimumAllowedPeriod,
                maximumAllowedPeriod: maximumAllowedPeriod,
                products: allowedProducts.sort(),
                excluded: excluded,
                isRevokesEnabled: excluded.reduce(function(memo, item) {
                    return memo ? memo : item.revoke;
                }, false),
                external: _.filter(productSettings, function(value) {
                    return value.product === 'external';
                })
            };
        },

        read: function(model, options) {
            return server.send({
                ID: 35601,
                responses: [35602, 35603],
                description: 'Get Player Self Exclusion'
            }).done(options.success);
        },

        update: function() {
            var period = this.get('period');
            var revokeProduct = this.get('revokeProduct');

            var request = {
                ID: 35631,
                description: 'Self Exclusion',
                responses: [35632, 35633]
            };

            if (revokeProduct) {
                request.product = revokeProduct;
                request.endSelfExclusion = 'revoke';
                this.set('revokeProduct', '');
            } else {
                request.product = this.get('product') || this.get('products')[0];
                request.period = period;
                request.endType = this.get('endType') || this.get('endTypes')[0];
            }

            if (period === 'enddate') {
                var date = new Date();
                date.setFullYear(this.get('year'), Number(this.get('month')) - 1, this.get('day'));

                request.endDate = window.Playtech.API.formatter.getDateForIms(date);
            }

            return server.send(request);
        }
    });
});
